import { publicEnv } from '@/config/env/public'

/** Configuração Supabase para clientes browser/SSR (anon key). */
export function getSupabaseClientConfig() {
  return {
    url: publicEnv.supabaseUrl,
    anonKey: publicEnv.supabaseAnonKey,
  }
}
